interface RecipeModuleLike {
  id: string;
  hotmart_product_id: string | null;
}

interface RecipeLike {
  module_id: string | null;
}

interface CountOwnedRecipeModulesArgs {
  recipeModules: RecipeModuleLike[];
  recipeCountsByModule: Record<string, number>;
  hasProduct: (productId: string) => boolean;
  excludedProductIds?: readonly string[];
}

export function buildRecipeCountsByModule(recipes: RecipeLike[]): Record<string, number> {
  return recipes.reduce<Record<string, number>>((counts, recipe) => {
    if (recipe.module_id) {
      counts[recipe.module_id] = (counts[recipe.module_id] || 0) + 1;
    }
    return counts;
  }, {});
}

export function countOwnedRecipeModules({
  recipeModules,
  recipeCountsByModule,
  hasProduct,
  excludedProductIds = [],
}: CountOwnedRecipeModulesArgs): number {
  const excluded = new Set(excludedProductIds);
  const ownedProductIds = new Set<string>();

  for (const module of recipeModules) {
    const productId = module.hotmart_product_id;
    if (!productId || excluded.has(productId) || !hasProduct(productId)) continue;
    if ((recipeCountsByModule[module.id] || 0) <= 0) continue;
    ownedProductIds.add(productId);
  }

  return ownedProductIds.size;
}